import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const Heading = ({
  title,
  className,
  headingRole = 'section',
}: {
  title: string;
  className?: string;
  headingRole?: 'primary' | 'section' | 'presentation';
}) => {
  const HeadingTag =
    headingRole === 'primary' ? 'h1' : headingRole === 'presentation' ? 'div' : 'h2';

  return (
    <HtmlRendererRaw
      as={HeadingTag}
      {...(headingRole === 'primary' ? { 'data-ea-primary-heading': true } : {})}
      className={cn(
        'text-3xl font-light uppercase sm:text-4xl lg:text-5xl xl:text-[52px]',
        'ea-heading',
        className,
      )}
      html={title}
    />
  );
};
